<template>
  <a class="activity-box" :class="cardInfo.type" :href="cardInfo.link" target="_blank" :style="{'background': `url(${cardInfo.imgSrc})`, 'margin-right': cardInfo.marginRight}">
    <div class="activity-content">
      <h1 class="title">{{cardInfo.title}}</h1>
      <p class="text">{{cardInfo.text}}</p>
    </div>
  </a>
</template>

<script>
export default {
  props: ['cardInfo']
}
</script>

<style lang="scss" scoped>
  @import '@/style/app.sass';

  .activity-box {
    position: relative;
    display: block;
    background-repeat: no-repeat !important;
    background-size: cover !important;
    background-position: center !important;
    height: 280px;
    // margin-right: 20px;
    margin-bottom: 20px;
    border-radius: 5px;
    @include mobile {
      width: 100% !important;
      height: 172px;
      .text {
        @include limit-line-numbers(2);
      }
    }
    &.rectangle {
      width: calc(50% - 10px);
    }
    &.square {
      width: calc((50% - 10px) / 2 - 10px);

      .text {
        @include limit-line-numbers(2);
      }
    }

    .activity-content {
      position: absolute;
      left: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.6);
      padding: 15px 25px 20px 25px;
      border-radius: 0 0 5px 5px;
      @include mobile {
        padding: 6px 12px;
      }

      .title {
        color: #fff;
        font-size: 18px;
        font-weight: 500;
        line-height: 24px;
        margin-bottom: 10px;
        @include mobile {
          font-size: 16px;
          line-height: 1;
          margin-bottom: 8px;
        }
      }

      .text {
        color: rgba(255, 255, 255, 0.8);
        font-size: 15px;
        font-weight: 400;
        line-height: 23px;
        @include mobile {
          font-size: 12px;
          line-height: 1.4;
        }
      }
    }
  }
</style>
